module.exports = __webpack_public_path__ + "static/img/ios.a2090fd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ios.png
// module id = uyCG
// module chunks = 1